import angular from 'angular';
import { InputEmailValidator } from '@updater/angular-common';
import { DateValidator } from './date';
import MinPatternValidatorModule from './min-pattern/min-pattern';
import ZipCodeValidatorModule from './zip-code/zip-code';
import SingleNameValidatorModule from './single-name/single-name';
import { StandardCharsValidator } from './standard-chars';
import AsyncEmailValidatorModule from './async-email/async-email';

export default angular.module('app.validators', [
  MinPatternValidatorModule.name,
  ZipCodeValidatorModule.name,
  SingleNameValidatorModule.name,
  StandardCharsValidator.name,
  DateValidator.name,
  InputEmailValidator.name,
  AsyncEmailValidatorModule.name,
]);
